import { http } from "./http";
import {
  CreateAddressRequest,
  CreateAddressResponse,
  FindUserAddressesResponse,
  UpdateAddressRequest,
} from "@/types/api/address";

export async function createAddress(req: CreateAddressRequest): Promise<CreateAddressResponse> {
  return http.post<CreateAddressResponse>("/api/address/create", req);
}

export async function updateAddress(req: UpdateAddressRequest): Promise<void> {
  return http.patch<void>("/api/address/update", req);
}

export async function findUserAddresses(): Promise<FindUserAddressesResponse[]> {
  return http.get<FindUserAddressesResponse[]>("/api/address/user-addresses");
}
